(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itencelle-reels"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('itencelle-reels')) {
  customElements.define('itencelle-reels', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.itr-track');
      if (!track) return;
      const nav = this.querySelector('.itr-nav');
      const buttons = [...nav.querySelectorAll('button')];
      nav.hidden = track.children.length < 2;
      const updateNavigation = () => {
        buttons[0].disabled = track.scrollLeft < 2;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal}));
      track.addEventListener('scroll', updateNavigation, {signal, passive: true});
      this.resizeObserver = new ResizeObserver(updateNavigation);
      this.resizeObserver.observe(track);
      updateNavigation();
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio < .55) entry.target.pause();
        });
      }, {threshold: [0, .55]});
      this.querySelectorAll('video').forEach(video => {
        const frame = video.closest('.itr-frame');
        const controls = frame.querySelector('.itr-controls');
        const play = controls.querySelector('[data-play]');
        const mute = controls.querySelector('[data-mute]');
        const progress = controls.querySelector('[data-progress]');
        const update = () => {
          frame.toggleAttribute('data-playing', !video.paused);
          frame.toggleAttribute('data-muted', video.muted);
          play.setAttribute('aria-label', video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          mute.setAttribute('aria-label', video.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
          progress.disabled = !Number.isFinite(video.duration) || video.duration <= 0;
          if (!progress.disabled) progress.value = video.currentTime / video.duration * 1000;
        };
        const toggle = () => {
          if (!video.paused) { video.pause(); return; }
          video.play().catch(() => {
            video.controls = true;
            controls.hidden = true;
          });
        };
        play.addEventListener('click', toggle, {signal});
        video.addEventListener('click', toggle, {signal});
        mute.addEventListener('click', () => { video.muted = !video.muted; }, {signal});
        progress.addEventListener('input', () => {
          if (Number.isFinite(video.duration)) video.currentTime = Number(progress.value) / 1000 * video.duration;
        }, {signal});
        video.addEventListener('play', () => {
          document.querySelectorAll('itencelle-reels video').forEach(other => { if (other !== video) other.pause(); });
          update();
        }, {signal});
        ['pause', 'ended', 'volumechange', 'timeupdate', 'loadedmetadata'].forEach(event => video.addEventListener(event, update, {signal}));
        this.observer.observe(video);
        video.controls = false;
        controls.hidden = false;
        update();
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, {signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itencelle-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('itencelle-return')) {
    customElements.define('itencelle-return', class extends HTMLElement {
      connectedCallback() {
        const main = document.querySelector('product-info[id^="MainProduct-"]');
        const info = main?.querySelector('.product__info-container');
        const buy = main?.querySelector('.product-form__submit');
        if (!info || !buy || !('IntersectionObserver' in window)) return;
        const link = this.querySelector('a');
        link.href = '#' + info.id;
        this.onClick = () => info.querySelector('h1')?.focus({preventScroll:true});
        const heading = info.querySelector('h1');
        if (heading) heading.tabIndex = -1;
        link.addEventListener('click', this.onClick);
        this.observer = new IntersectionObserver(([entry]) => {
          this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        });
        this.observer.observe(buy);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.querySelector('a')?.removeEventListener('click', this.onClick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
